import {useSelector} from 'react-redux';

import {
	contactListAccessViewRoles,
	dashboardAccessViewRoles,
	groupRiskAssessmentAccessViewRoles
} from '../../util/uiconstants';

export const getAccessPermissions = ({userId, projects}) => {
	let userPermissionsInProject = [];
	projects?.forEach((project) => {
		const user = project?.users?.find((user) => user.userId === userId);
		const isProjectOwner = !!user?.isProjectOwner || project?.owners?.find((user) => user.userId === userId);

		const hasDashboardRoles = !!user?.roles?.some((role) => dashboardAccessViewRoles.includes(role));
		const hasGroupRiskRoles = !!user?.roles?.some((role) => groupRiskAssessmentAccessViewRoles.includes(role));
		const hasContactListRoles = !!user?.roles?.some((role) => contactListAccessViewRoles.includes(role));

		const isGroupRiskAssessmentProject = project?.isGroupRiskAssessmentProject;

		const isActiveProject = project?.status === 'active';

		userPermissionsInProject.push({
			projectId: project.projectId,
			projectName: project.name,
			dashboardAccess: (isProjectOwner || hasDashboardRoles) && isActiveProject,
			groupRiskAssessmentAccess:
				(isProjectOwner || hasGroupRiskRoles) && isActiveProject && isGroupRiskAssessmentProject,
			contactListAccess: (isProjectOwner || hasContactListRoles) && isActiveProject
		});
	});
	return userPermissionsInProject?.sort((a, b) => a.projectName?.localeCompare(b.projectName));
};

export default () =>
	useSelector(({ovsProject, userPreferences}) => {
		return getAccessPermissions({
			userId: userPreferences.userGui,
			projects: ovsProject?.projects
		});
	});
